import globalAxios from 'axios';
import { assertParamExists, DUMMY_BASE_URL, setApiKeyToObject, setSearchParams, toPathString, serializeDataIfNeeded, createRequestFunction } from '../common.js';
import { operationServerMap, BaseAPI, BASE_PATH } from '../base.js';

/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 *
 * Jellyfin API
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/**
 * LyricsApi - axios parameter creator
 * @export
 */
const LyricsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Deletes an external lyric file.
         * @param {string} itemId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLyrics: async (itemId, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteLyrics', 'itemId', itemId);
            const localVarPath = `/Audio/{itemId}/Lyrics`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Downloads a remote lyric.
         * @param {string} itemId The item id.
         * @param {string} lyricId The lyric id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRemoteLyrics: async (itemId, lyricId, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('downloadRemoteLyrics', 'itemId', itemId);
            // verify required parameter 'lyricId' is not null or undefined
            assertParamExists('downloadRemoteLyrics', 'lyricId', lyricId);
            const localVarPath = `/Audio/{itemId}/RemoteSearch/Lyrics/{lyricId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)))
                .replace(`{${"lyricId"}}`, encodeURIComponent(String(lyricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets an item\'s lyrics.
         * @param {string} itemId Item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLyrics: async (itemId, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('getLyrics', 'itemId', itemId);
            const localVarPath = `/Audio/{itemId}/Lyrics`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets the remote lyrics.
         * @param {string} lyricId The remote provider item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemoteLyrics: async (lyricId, options = {}) => {
            // verify required parameter 'lyricId' is not null or undefined
            assertParamExists('getRemoteLyrics', 'lyricId', lyricId);
            const localVarPath = `/Providers/Lyrics/{lyricId}`
                .replace(`{${"lyricId"}}`, encodeURIComponent(String(lyricId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Search remote lyrics.
         * @param {string} itemId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemoteLyrics: async (itemId, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('searchRemoteLyrics', 'itemId', itemId);
            const localVarPath = `/Audio/{itemId}/RemoteSearch/Lyrics`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Upload an external lyric file.
         * @param {string} itemId The item the lyric belongs to.
         * @param {string} fileName Name of the file being uploaded.
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLyrics: async (itemId, fileName, body, options = {}) => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('uploadLyrics', 'itemId', itemId);
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('uploadLyrics', 'fileName', fileName);
            const localVarPath = `/Audio/{itemId}/Lyrics`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication CustomAuthentication required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration);
            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }
            localVarHeaderParameter['Content-Type'] = 'text/plain';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LyricsApi - functional programming interface
 * @export
 */
const LyricsApiFp = function (configuration) {
    const localVarAxiosParamCreator = LyricsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Deletes an external lyric file.
         * @param {string} itemId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLyrics(itemId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLyrics(itemId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.deleteLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Downloads a remote lyric.
         * @param {string} itemId The item id.
         * @param {string} lyricId The lyric id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRemoteLyrics(itemId, lyricId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRemoteLyrics(itemId, lyricId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.downloadRemoteLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets an item\'s lyrics.
         * @param {string} itemId Item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLyrics(itemId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLyrics(itemId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.getLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets the remote lyrics.
         * @param {string} lyricId The remote provider item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRemoteLyrics(lyricId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRemoteLyrics(lyricId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.getRemoteLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Search remote lyrics.
         * @param {string} itemId The item id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchRemoteLyrics(itemId, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchRemoteLyrics(itemId, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.searchRemoteLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Upload an external lyric file.
         * @param {string} itemId The item the lyric belongs to.
         * @param {string} fileName Name of the file being uploaded.
         * @param {File} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadLyrics(itemId, fileName, body, options) {
            var _a, _b, _c;
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadLyrics(itemId, fileName, body, options);
            const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
            const localVarOperationServerBasePath = (_c = (_b = operationServerMap['LyricsApi.uploadLyrics']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * LyricsApi - factory interface
 * @export
 */
const LyricsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = LyricsApiFp(configuration);
    return {
        /**
         *
         * @summary Deletes an external lyric file.
         * @param {LyricsApiDeleteLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLyrics(requestParameters, options) {
            return localVarFp.deleteLyrics(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Downloads a remote lyric.
         * @param {LyricsApiDownloadRemoteLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRemoteLyrics(requestParameters, options) {
            return localVarFp.downloadRemoteLyrics(requestParameters.itemId, requestParameters.lyricId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets an item\'s lyrics.
         * @param {LyricsApiGetLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLyrics(requestParameters, options) {
            return localVarFp.getLyrics(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets the remote lyrics.
         * @param {LyricsApiGetRemoteLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRemoteLyrics(requestParameters, options) {
            return localVarFp.getRemoteLyrics(requestParameters.lyricId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search remote lyrics.
         * @param {LyricsApiSearchRemoteLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchRemoteLyrics(requestParameters, options) {
            return localVarFp.searchRemoteLyrics(requestParameters.itemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload an external lyric file.
         * @param {LyricsApiUploadLyricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadLyrics(requestParameters, options) {
            return localVarFp.uploadLyrics(requestParameters.itemId, requestParameters.fileName, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * LyricsApi - object-oriented interface
 * @export
 * @class LyricsApi
 * @extends {BaseAPI}
 */
class LyricsApi extends BaseAPI {
    /**
     *
     * @summary Deletes an external lyric file.
     * @param {LyricsApiDeleteLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    deleteLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).deleteLyrics(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Downloads a remote lyric.
     * @param {LyricsApiDownloadRemoteLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    downloadRemoteLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).downloadRemoteLyrics(requestParameters.itemId, requestParameters.lyricId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets an item\'s lyrics.
     * @param {LyricsApiGetLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    getLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).getLyrics(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets the remote lyrics.
     * @param {LyricsApiGetRemoteLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    getRemoteLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).getRemoteLyrics(requestParameters.lyricId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search remote lyrics.
     * @param {LyricsApiSearchRemoteLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    searchRemoteLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).searchRemoteLyrics(requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upload an external lyric file.
     * @param {LyricsApiUploadLyricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LyricsApi
     */
    uploadLyrics(requestParameters, options) {
        return LyricsApiFp(this.configuration).uploadLyrics(requestParameters.itemId, requestParameters.fileName, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}

export { LyricsApi, LyricsApiAxiosParamCreator, LyricsApiFactory, LyricsApiFp };
